import React from "react";



const SecondPane = () => (
    <div className="uk-container">
    <div className="uk-width-1-1">
        <h3  className="withPaddingLarge" uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true">With the right tools, an open mindset and the proper setting, all
             children have the chance to receive top education. Schools do their 
             part, we do the rest. Always with the future in mind, we bring the 
             best tech education has to offer. We support traditional education 
             providers by offering in-depth tech courses and tutoring sessions for essential topics.</h3>
    </div>

</div>
);



export default SecondPane;